import { inject } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import Keycloak from 'keycloak-js';

const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean> => {

  if (authData.authenticated) {
    return true;
  }

  const keycloak = inject(Keycloak);

  await keycloak.login({
    redirectUri: window.location.origin + state.url
  });

  return false;
};

export const canActivateAuthRole =
  createAuthGuard(isAccessAllowed);
